/**
 * Fingerprint utility for tracking guest users
 * Generates a unique fingerprint for guests and stores it in localStorage
 * For authenticated users, their user ID is used as fingerprint
 */

const FINGERPRINT_KEY = 'user_fingerprint';

/**
 * Generate a UUID v4
 */
const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Get or create fingerprint for guest users
 */
export const getGuestFingerprint = (): string => {
  let fingerprint = localStorage.getItem(FINGERPRINT_KEY);

  if (!fingerprint) {
    fingerprint = generateUUID();
    localStorage.setItem(FINGERPRINT_KEY, fingerprint);
  }

  return fingerprint;
};

/**
 * Get fingerprint for the current user
 * Uses user ID if authenticated, otherwise generates/retrieves guest fingerprint
 */
export const getFingerprint = (userId?: string): string => {
  if (userId) {
    return userId;
  }

  return getGuestFingerprint();
};

/**
 * Clear fingerprint from localStorage
 * Useful when user logs out
 */
export const clearFingerprint = (): void => {
  localStorage.removeItem(FINGERPRINT_KEY);
};
